import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  Cart,
  RestaurantCart,
  SelectedArticle,
} from "../../../../../../../interfaces/Catalogue";
import { updateCart } from "../../../../../../../store/cart/cartActions";
import {
  getPurchaseOfferMessage,
  getRemiseMessage,
} from "../../../../../../../utils/loyaltyUtils";
import {
  calculatediscountedPrice,
  calculateMenuFinalPrice,
  findPriceByTypeOrder,
} from "../../../../../../../utils/priceUtils";
import IngredientDetails from "../../../../../IngedientDetails/IngredientDetails";
import RewardClaimButton from "../../../../../RewardClaimButton/RewardClaimButton";

interface OrderMenuArticlePops {
  currentArticle: SelectedArticle;
  orderItemIndex: number;
  orderType: number;
  restaurantId?: number;
  categoryItemId: number;
  canApplyArticleDiscount: boolean;
  rewardClaimDisabled?: boolean;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;
}

const OrderMenuArticle = (props: OrderMenuArticlePops) => {
  const {
    orderItemIndex,
    currentArticle,
    orderType,
    restaurantId,
    categoryItemId,
    userLoyalityPoints,
    canApplyArticleDiscount,
    rewardClaimDisabled,
    totalLoyaltyPtsConsomed,
  } = props;

  // const [isRemiseActive, setIsRemiseActive] = useState(
  //   currentArticle?.selectedMenuItem.isRemiseActive || false
  // );

  const dispatch = useDispatch();
  const restaurantCarts = useSelector(
    (state: { cart: Cart }) => state.cart.restaurantCarts
  );

  const restaurantCart: RestaurantCart = restaurantCarts[restaurantId || 0];

  const priceByOrderType = findPriceByTypeOrder(
    currentArticle?.selectedMenuItem.typeOrderPrices,
    orderType
  );

  const updateArticleLoyality = (isRemiseActive: boolean) => {
    if (restaurantId) {
      // Clone restaurantCarts to avoid mutation
      let updatedSavedCart = { ...restaurantCarts };

      // Find the matching category
      const matchingCategory = updatedSavedCart[restaurantId]?.categories.find(
        (category, index) => {
          return category.id === categoryItemId && index === orderItemIndex;
        }
      );

      if (matchingCategory) {
        // Loop through orders and update the article
        matchingCategory.order?.forEach((order) => {
          order.selectedArticles.forEach((selectArticle) => {
            const { selectedMenuItem } = selectArticle;

            if (currentArticle.selectedMenuItem.id === selectedMenuItem.id) {
              // setIsRemiseActive(!selectedMenuItem.isRemiseActive);

              selectedMenuItem.isRemiseActive = !selectedMenuItem?.isRemiseActive;

              const priceByTypeOrder =
                findPriceByTypeOrder(
                  selectedMenuItem.typeOrderPrices,
                  restaurantCart.mode
                ) || 0;

              selectedMenuItem.discountedPrice = isRemiseActive
                ? calculatediscountedPrice(
                    priceByTypeOrder,
                    selectedMenuItem?.rewardDiscountType,
                    selectedMenuItem?.rewardDiscountValue
                  )
                : null;
            }
          });
        });

        const discountedPrice = calculateMenuFinalPrice(
          matchingCategory?.order || [],
          restaurantCart.mode,
          true
        );
        const originalPrice = calculateMenuFinalPrice(
          matchingCategory?.order || [],
          restaurantCart.mode,
          false
        );

        matchingCategory.discountedPrice =
          discountedPrice == originalPrice ? null : discountedPrice;

        // Dispatch updated cart
        dispatch(updateCart(updatedSavedCart));
      }
    }
  };

  return (
    <div key={currentArticle.selectedMenuItem.id} className="menusItemList">
      <div className="SingleMenuList">
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent="space-between"
        >
          <p className="menuSubName" style={{ textTransform: "uppercase" }}>
            {currentArticle?.selectedMenuItem?.quantity}{" "}
            {currentArticle?.selectedMenuItem?.name}{" "}
            {priceByOrderType > 0 && (
              <>
                <span> ( </span>
                <span
                  className={
                    currentArticle?.selectedMenuItem?.discountedPrice != null
                      ? "discount-price"
                      : ""
                  }
                >
                  {priceByOrderType} €
                </span>
                {currentArticle?.selectedMenuItem?.discountedPrice != null && (
                  <span>
                    {currentArticle?.selectedMenuItem?.discountedPrice === 0
                      ? " / Gratuit"
                      : ` / ${currentArticle?.selectedMenuItem?.discountedPrice} €`}
                  </span>
                )}
                <span> ) </span>
              </>
            )}
          </p>
          {canApplyArticleDiscount && (
            <RewardClaimButton
              articleClaimed={
                currentArticle?.selectedMenuItem.isRemiseActive || false
              }
              selectedMenuItem={currentArticle?.selectedMenuItem}
              updateArticleLoyality={updateArticleLoyality}
              isClaimDisabled={rewardClaimDisabled || false}
            />
          )}
        </Box>
        {currentArticle?.selectedMenuItem?.rewardTotalPtRequired &&
          canApplyArticleDiscount && (
            <p className="discountMessage">
              {getRemiseMessage(currentArticle?.selectedMenuItem)}
            </p>
          )}
        {currentArticle?.selectedMenuItem?.purchaseOffers && (
          <p className="discountMessage">
            {getPurchaseOfferMessage(
              currentArticle?.selectedMenuItem?.purchaseOffers
            )}
          </p>
        )}

        <IngredientDetails
          selectedIngredients={currentArticle?.selectedIngredients}
          orderType={orderType}
        />
      </div>
    </div>
  );
};

export default OrderMenuArticle;
